import { AllowedButtons, driver } from "driver.js";
import "driver.js/dist/driver.css";
import { DriverStepConfig } from "./steps";
import { completeTour } from "./tour";

// Драйвер
export const driverObj = driver({
    showProgress: true,

    prevBtnText: "Назад",
    nextBtnText: "Далее",
    doneBtnText: "Понятно",
    progressText: "{{current}} из {{total}}",

    showButtons: ['next', 'previous', 'close'],
    popoverClass: 'dark-blue-theme',
    allowClose: false,

    // Завершение тура после окончания или сброса
    onDestroyed: () => {
        completeTour();
    }
});



/**
 * Ожидание появление элемента в DOM дереве
 * для начала выполнения следующего шага тура
 * @param selector CSS селектор элемента
 * @param timeout Ожидание появления
 * @returns Найденный селектором элемент
 * @example waitFor: () => waitForElement('#dynamicButton', 10000))
 */
export function waitForElement(
  selector: string,
  timeout = 6000
): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const isVisible = (el: HTMLElement) => {
      const style = window.getComputedStyle(el);

      const rect = el.getBoundingClientRect();

      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        parseFloat(style.opacity) > 0 &&
        rect.width > 0 &&
        rect.height > 0
      );
    };

    const check = () => {
      const el = document.querySelector(selector) as HTMLElement | null;

      if (el && isVisible(el)) {
        // даём один кадр чтобы закончилась анимация
        requestAnimationFrame(() => resolve(el));
        return;
      }

      if (Date.now() - start > timeout) {
        reject(`Element "${selector}" not visible after ${timeout}ms`);
        return;
      }

      requestAnimationFrame(check);
    };

    check();
  });
}

/**
 * Ожидание действий пользователя
 * @param callback функция с вызовом resolve()
 * @returns 
 * @example waitFor: () => waitForUserAction(resolve => {
      document.querySelector('#folderDropdownBtn')?.addEventListener('click', () => {
        resolve(); // как только клик — продолжаем тур
      }, { once: true });
    })
 */
export const waitForUserAction = (callback: (resolve: () => void) => void): Promise<void> => {
    return new Promise(resolve => callback(resolve));
}

/**
 * Ожидание ответа от сервера, для продолжения тура
 * @param apiCall fet
 * @returns 
 * @example waitFor: () => waitForApi(() => fetch('/api/files').then(res => res.json()))
 */
export const waitForApi = <T>(apiCall: () => Promise<T>): Promise<T> => {
  return apiCall();
}


/**
 * Обработка массива шагов
 * для правильно реализации waitFor
 * @param steps шаги
 * @returns обработанные шаги
 */
export function prepareSteps(steps: DriverStepConfig[]) {
  return steps.map((step) => {
    if (!step.waitFor) return step;

    return {
      ...step,
      popover: {
        ...step.popover,
        showButtons: ['close'] as AllowedButtons[], // пользователь не может нажать Next
      },
      onHighlighted: async () => {
        await step.waitFor?.();
        driverObj.moveNext();
      }
    };
  });
}